import { FC } from 'react';
import { FrequencyCapsProvider } from '../context/FrequencyCapsProvider';
import FrequencyCapsList from '../components/FrequencyCapsList';
import { MainArea, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';

export const FrequencyCapsListPage: FC = () => {
  return (
    <FrequencyCapsProvider>
      <MainArea>
        <TopArea>
          <AppTopBar />
        </TopArea>
        <FrequencyCapsList />
      </MainArea>
    </FrequencyCapsProvider>
  );
};
